import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../constants/colors/Colors';
export const useStyles = makeStyles((theme) => ({
    tabsAndBtnRow: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 40,
        "@media (max-width: 700px)": {
            display: 'block'
        },
    },
    tabsRow: {
        width: 350,
        display: 'flex',
        backgroundColor: '#E6EDF3',
        borderRadius: 6,
        height: 50,
        justifyContent: 'space-between',
        "@media (max-width: 700px)": {
            width: '100%',
        },
    },
    notSelectedTab: {
        width: 70,
        height: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: colors.titleColor,
        fontSize: 16,
        fontWeight: '600',
        "@media (max-width: 700px)": {
            width: '20%',
            fontSize: 14,
        },
    },
    selectedTab: {
        width: 70,
        height: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        borderRadius: 6,
        background: 'linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)',
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '600',
        "@media (max-width: 700px)": {
            width: '20%',
            fontSize: 14,
        },
    },
    integrationBtn: {
        width: 228,
        height: 50,
        background: 'linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)',
        border: '1px solid #824ED2',
        borderRadius: 4,
        color: '#FFFFFF',
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: '600',
        letterSpacing: '-0.1px',
        "@media (max-width: 1000px)": {
            width: 200,
            fontSize: 12,
        },
        "@media (max-width: 700px)": {
            marginTop: 20,
            width: '100%',
            fontSize: 14,
        },
    },
    graphTitle: {
        color: colors.titleColor,
        fontSize: 16,
        fontWeight: '600',
        marginTop: 40,
    },
    graphLinesClrsIndicatorsRow: {
        display: 'flex',
        marginTop: -15,
        whiteSpace: 'nowrap',
        flexWrap: 'wrap',
    },
    clrAndNameRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 24,
    },
    blueClrContainer: {
        width: 12,
        height: 12,
        backgroundColor: colors.primary,
        borderRadius: 2,
    },
    greenClrContainer: {
        backgroundColor: '#12B681',
        width: 12,
        height: 12,
        borderRadius: 2,
    },
    orangeClrContainer:{
        backgroundColor: '#CFA639',
        width: 12,
        height: 12,
        borderRadius: 2,
    },
    clrTitle: {
        color: '#5B6773',
        letterSpacing: '-0.1px',
        fontSize: 14,
        fontWeight: '400',
        marginLeft: 7,
    },
    graphContainer:{
        width:'100%',
        height:246,
        backgroundColor:'#ffff',
        borderRadius:12,
        padding:'30px 37px 30px 36px',
    },
}));